export default {
  container: {
    margin: "-12px",
    width: "calc(100% + 24px)"
  },
  item: {
    padding: "12px",
    ['@media (max-width: 992px)']: {
      flexBasis: "100%",
    },
    ['@media (max-width: 768px)']: {
      padding: "6px 12px",
    },
  }
};
